import React, { useEffect, useState } from "react";

const messages = [
    "MAKE YOUR HEALTH BETTER",
    "100% CHEMICAL-FREE",
    "NATURALLY DRIED",
    "FSSAI · ISO 22000 · HACCP",
    "EXPORTED TO 40+ COUNTRIES",
    "MILLED IN SURAT, INDIA",
];

const TickerBar = () => {
    const [paused, setPaused] = useState(false);
    useEffect(() => {}, [paused]);
    return (
        <div
            data-testid="ticker-bar"
            className="bg-sunrise text-white overflow-hidden py-3 relative"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
        >
            <div className={`marquee-track gap-12 ${paused ? "[animation-play-state:paused]" : ""}`}>
                {[...messages, ...messages, ...messages].map((m, i) => (
                    <span
                        key={i}
                        className="font-mono text-xs uppercase tracking-[0.32em] flex items-center gap-12 whitespace-nowrap font-medium"
                    >
                        {m}
                        <span aria-hidden className="text-sun-gold">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
};

export default TickerBar;
